
    <p-progressSpinner [style]="{width: '50px', height: '50px'}" strokeWidth="2" fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
    